// extracted by mini-css-extract-plugin
export var bounce = "_p6-1";
export var generatingText = "_p6-6";
export var lightning = "_p6-4";
export var popup = "_p6-5";
export var progressBar = "_p6-7";
export var progressFill = "_p6-8";
export var progressShimmer = "_p6-9";
export var progressText = "_p6-a";
export var shimmer = "_p6-3";
export var uploadIcon = "_p6-0";
export var uploadingText = "_p6-2";